<template>
	<div class="jobCard">
		<div class="left">
      <div class="row">
        <span class="name">会计助理</span>
        <span class="price">4980元/月</span>
      </div>
			<div class="row-ab">
        <div>
          <div class="tags">
            <span>经验不限</span>
            <span>学历不限</span>
          </div>
          <div class="location">
            <img src="../static/img/Vector@2x.png" alt="">
            <span>东莞•东城街道•旗峰路</span>
          </div>
        </div>
        <div class="btn-sign">
          <span>立即报名</span>
          <img class="icon-left" src="../static/img/icon_left.png" alt="">
        </div>
      </div>
		</div>
		<div class="right">
			
		</div>
	</div>
</template>

<script>
	export default {
		name:"jobCard",
		data() {
			return {
				
			};
		}
	}
</script>

<style scoped lang="scss">
	.jobCard{
		box-sizing: border-box;
		padding: 1vw;
		width: 30.31vw;
		background: #FFFFFF;
		box-shadow: 0px 0px 14px 0px rgba(10,161,241,0.2);
		border-radius: 0.5vw;
		margin: 1vw 1vw 0;
		cursor: default;
		
		.left{
			display: flex;
			flex-direction: column;

      .name{
        font-size: 1.25vw;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: bold;
        color: #212F46;
      }
			
      .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .row-ab {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
      }

      .price {
        color: #FF3737;
        font-size: 1.25vw;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: bold;
      }

      .btn-sign {
        display: flex;
        align-items: center;
        background-color: #0B4EF4;
        padding: 0.5vw;
        border-radius: 0.6vw;
        color: #fff;
        font-size: 0.8vw;
        .icon-left {
          width:0.6vw;
          margin-left: 0.5vw;
        }
      }
			
			.tags{
				margin-bottom: 0.4vw;
				>span{
					display: inline-block;
					padding: 1px;
					margin-right: 0.5vw;
					background: rgba(138,151,169,0.12);
					border-radius: 2px 2px 2px 2px;
					font-size: 0.625vw;
					font-family: Source Han Sans CN-Medium, Source Han Sans CN;
					font-weight: 500;
					color: #8A97A9;
				}
			}
			.location{
				display: flex;
				align-items: center;
				>img{
					width: 0.9vw;
					height: 1.1vw;
				}
				font-size: 1vw;
				font-family: Source Han Sans CN-Medium, Source Han Sans CN;
				font-weight: 500;
				color: #546176;
			}
			
		}
		
		
	}
</style>